import { render, staticRenderFns } from "./employe.vue?vue&type=template&id=e7f6c4a2&scoped=true"
import script from "./employe.vue?vue&type=script&lang=js"
export * from "./employe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f6c4a2",
  null
  
)

export default component.exports